module.exports = __webpack_public_path__ + "img/优米购专场券.950f53b1.png";